import { render } from "./logoffSuccessModal.vue?vue&type=template&id=111544c6&scoped=true&ts=true"
import script from "./logoffSuccessModal.vue?vue&type=script&lang=ts"
export * from "./logoffSuccessModal.vue?vue&type=script&lang=ts"

import "./logoffSuccessModal.vue?vue&type=style&index=0&id=111544c6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111544c6"]])